import { Modal } from "@mui/material";
import { useState } from "react";



const AddExchange=({toggleExchange,exchange,setExchange})=>{
    const [allExchange]=useState([
        'Coinbase',
        'Binance', 
        'KuCoin', 
        'Crypto', 
        'Kraken',
        'Bitstamp', 
        'Gate.io',
        'iTrust',
        'eToro', 
        'UpHold', 
        'Public.com' ])
    const [selected,setSelected]=useState(exchange);

    const onChange=(e)=>{
        if(selected.includes(e.target.name)){
            let index=selected.indexOf(e.target.name);
            selected.splice(index,1)
            setSelected([...selected]);
        }else{
            setSelected([...selected,e.target.name])
        }
       
    }
  
    return(
        <Modal
         keepMounted
         open={true}
         onClose={()=>{}}
         aria-labelledby="keep-mounted-modal-title"
         aria-describedby="keep-mounted-modal-description"
        >
        <div className="col-12 d-flex  flex-wrap">
            {allExchange.map((name)=>{
                return(
                    <div className="col-4 my-2 p-1 ps-5 text-start ">
             <input type="checkbox" name={name} checked={selected.includes(name)} id={`checkbox-${name}`} onChange={onChange} />
             <label class="custom-control-label ms-2" for={`checkbox-${name}`}>{name}</label>
            </div>
                )
            })}
        </div>
        </Modal>
    )
}

export default AddExchange;


